import { Button, VStack, HStack, Text, Divider, PinInput, PinInputField, useBreakpointValue, Box, Icon, Flex } from '@chakra-ui/react'
import React from 'react'
import { useForm, Controller } from 'react-hook-form'
import { MdVpnKey } from 'react-icons/md'
import { useReservation } from './ReservationContext'
import ReservationInfoPanel from './ReservationInfoPanel'

type FormData = {
  password: string
}

const ReservationCreatePassword: React.FC = () => {
  const { state, goToNext, goBack } = useReservation()
  const isMobile = useBreakpointValue({ base: true, md: false })

  const {
    control,
    handleSubmit,
    formState: { errors, isValid }
  } = useForm<FormData>({
    mode: 'onChange',
    defaultValues: {
      password: state.password || ''
    }
  })

  const onSubmit = (data: FormData) => {
    goToNext({ password: data.password })
  }

  const handleNext = handleSubmit(onSubmit)

  return (
    <VStack spacing={6} align="stretch" width="100%" maxW="100%">     
      <Flex alignItems="center" gap="8px">
        <Icon as={MdVpnKey} boxSize="20px" color="gray.700" />
        <Text fontSize="18px" fontWeight="600" wordBreak="break-word" whiteSpace="normal">
          パスワードを設定してください
        </Text>
      </Flex>
      <Text fontSize="14px" color="gray.600" mt={-2} wordBreak="break-word" whiteSpace="normal">
        数字6桁で設定してください
      </Text>
      <HStack align="center" justify={isMobile ? "center" : "flex-start"} w="100%">
        <Controller
          name="password"
          control={control}
          rules={{
            required: 'パスワードは必須です',
            validate: (value) => {
              if (!value || value.length === 0) {
                return 'パスワードは必須です'
              }
              if (!/^\d+$/.test(value)) {
                return '数字以外は設定できません'
              }
              if (value.length < 6) {
                return 'パスワードは6文字すべて入力してください'
              }
              return true
            }
          }}
          render={({ field: { onChange, onBlur, value } }) => (
            <PinInput
              size="lg"
              placeholder=""
              value={value}
              onChange={onChange}
              type="number"
              mask
            >
              <PinInputField onBlur={onBlur} inputMode="numeric" />
              <PinInputField onBlur={onBlur} inputMode="numeric" />
              <PinInputField onBlur={onBlur} inputMode="numeric" />
              <PinInputField onBlur={onBlur} inputMode="numeric" />
              <PinInputField onBlur={onBlur} inputMode="numeric" />
              <PinInputField onBlur={onBlur} inputMode="numeric" />
            </PinInput>
          )}
        />
      </HStack>
      {errors.password && (
        <Text color="red.500" fontSize="14px" wordBreak="break-word" whiteSpace="normal">
          {errors.password.message}
        </Text>
      )}
      <Divider />
      <Box w="100%" maxW="100%">
        <ReservationInfoPanel showTitle />
      </Box>
      {isMobile ? (
        <VStack spacing={3} mt={4} w="100%">
          <Button onClick={goBack} size="md" width="100%" variant="outline">戻る</Button>
          <Button colorScheme="green" onClick={handleNext} isDisabled={!isValid || !!errors.password} size="md" width="100%">
            次へ
          </Button>
        </VStack>
      ) : (
        <HStack justify="space-between" mt={4} w="100%">
          <Button onClick={goBack} size="md">戻る</Button>
          <Button colorScheme="green" onClick={handleNext} isDisabled={!isValid || !!errors.password} size="md">
            次へ
          </Button>
        </HStack>
      )}
    </VStack>
  )
}

export default ReservationCreatePassword 